export default "__VITE_ASSET__BmkWHal6__";